// Module
var code = "<cr-data-error has-data-error=\"true\"> <div>{{ ::$ctrl.text.ohNoPageNotFound }}</div> <div> <span>{{ ::$ctrl.text.pleaseTryADifferentUrlOrGoToThe }}</span> <a ui-sref=\"client\">{{ ::$ctrl.text.homePage }}.</a> </div> </cr-data-error> ";
// Exports
export default code;